import { observer } from "mobx-react";
import React, { useEffect } from "react";
import { GetAChannel } from "../../stores/GetAChannel";

const GetInfo: React.FC<{ getAChannel: GetAChannel }> = observer(
  ({ getAChannel }) => {
    // useEffect(() => {
    //   getAChannel.fetchGetInfo();
    // }, [getAChannel]);

    return null; // No UI; only fetches data
  }
);

export default GetInfo;
